import {
  Component,
  OnInit,
  ViewChild,
  Renderer,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { VolvoApiService } from "../../services/volvo-api.service";
import { PageConfiguration } from "../../models/page-configuration";
import { Title } from '@angular/platform-browser';

@Component({
  selector: "app-privacy",
  templateUrl: "./privacy.component.html",
  styleUrls: ["./privacy.component.scss"],
})
export class PrivacyComponent implements OnInit {
  @ViewChild("pagecontent") pageContent: ElementRef;
  public pageConfig$: Observable<PageConfiguration>;
  localStrings$: Observable<Array<any>>;

  promotionAlias: string;
  isHotelPromotion: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private volvoApi: VolvoApiService,
    private router: Router,
    private renderer: Renderer,
    private titleService: Title,
    // private metaService: Meta
  ) {}

  ngOnInit() {

    this.promotionAlias = this.route.snapshot.paramMap.get("promotionAlias");

    this.route.data.subscribe(data => {
        if(data.isHotelPromotion) {
          this.isHotelPromotion = data.isHotelPromotion;
        }
    })

    if(this.isHotelPromotion) {
      this.pageConfig$ = this.volvoApi.getHotelPageConfiguration(this.promotionAlias);
    } else {
      this.pageConfig$ = this.volvoApi.getPageConfiguration(this.promotionAlias);
    }


    this.pageConfig$.subscribe((r) => {
      // redirect to main site when page doesn't exist
      if (!r.ID) {
        this.router.navigateByUrl("notfound");
      }

      const _pagetitle = r.PageTitle ? r.PageTitle : "Volvo Affinity Programs";
      this.titleService.setTitle(_pagetitle);

      // // Meta Tags - Primary
      // this.metaService.addTag({ name: 'title', content: _pagetitle });
      // this.metaService.addTag({ name: 'description', content: r.PageDescription });

      // // Meta Tags - Open Graph / Facebook
      // this.metaService.addTag({ property: 'og:type', content: 'website' });
      // this.metaService.addTag({ property: 'og:url', content: window.location.href });
      // this.metaService.addTag({ property: 'og:title', content: _pagetitle });
      // this.metaService.addTag({ property: 'og:description', content: r.PageDescription });
      // this.metaService.addTag({ property: 'og:image', content: r.PageMetaImg });
      
      // // Meta Tags - Twitter
      // this.metaService.addTag({ property: 'twitter:card', content: 'summary_large_image' });
      // this.metaService.addTag({ property: 'twitter:url', content: window.location.href });
      // this.metaService.addTag({ property: 'twitter:title', content: _pagetitle });
      // this.metaService.addTag({ property: 'twitter:description', content: r.PageDescription });
      // this.metaService.addTag({ property: 'twitter:image', content: r.PageMetaImg });

    });

    this.localStrings$ = this.volvoApi.getPromotionLocalizationString();
  }

  skipToContent() {
    this.renderer.invokeElementMethod(this.pageContent.nativeElement, "focus");
  }
}
